module.exports = __webpack_public_path__ + "img/ex.25ed8a49.svg";